<template>
  <div class="shop-list no-scrollbar" :class="$store.state.theme">
    <!-- if sorting by category -->
    <div v-if="sortBy === 'category'" style="width: 100%">
      <span class="buttons is-centered single-line sort-by">
        <span
          v-show="category"
          class="button is-info is-small is-rounded"
          :class="{ 'is-outlined': category }"
          @click="category = null"
        >
          <span class="icon">
            <i class="fa fa-times-circle" />
          </span>
        </span>
        <span
          v-for="c in categories"
          v-show="c"
          :key="c"
          class="button is-info is-small has-text-weight-medium"
          :class="{ 'is-outlined': category !== c }"
          @click="category = c"
          >{{ translateCategory(c) }}</span
        >
      </span>
    </div>

    <!-- if sorting by filter -->
    <div v-if="sortBy === 'filter'" style="width: 100%">
      <span class="buttons is-centered single-line sort-by">
        <span
          v-show="filter"
          class="button is-primary is-small is-rounded"
          :class="{ 'is-outlined': filter }"
          @click="filter = null"
        >
          <span class="icon">
            <i class="fa fa-times-circle" />
          </span>
        </span>
        <span
          v-for="f in filters"
          v-show="f"
          :key="f"
          class="button is-primary is-small has-text-weight-medium"
          :class="{ 'is-outlined': filter !== f }"
          @click="filter = f"
          >{{ translateFilter(f) }}</span
        >
      </span>
    </div>

    <div class="card" v-if="noBusinesses">
      <div class="card-content" style="padding: 12px" @click="refreshPage">
        <span class="button is-white has-text-primary has-text-weight-medium">{{
          $t("shop.search-no-shop")
        }}</span>
        <span class="button is-rounded is-primary is-outlined">{{
          $t("try-again")
        }}</span>
        <!-- should clear the search terms and categories etc, not reload page... -->
      </div>
    </div>

    <div
      class="shops-wrapper no-scrollbar gpu-accelerated"
      style="overflow-y: scroll; height: 100%"
    >
      <div
        class="card shop-card"
        v-for="b in businesses"
        :key="b.id"
        @click="openShopPage(b.id)"
      >
        <div class="card-content" style="padding: 6px">
          <div class="media" style="margin-bottom: 0">
            <div class="media-left" style="margin-right: 8px">
              <figure class="image">
                <img v-webp="businessProfilePic(b)" @error="defaultImg" />
              </figure>
            </div>
            <div class="media-content" style="margin-top: 6px">
              <span class="has-text-weight-medium has-text-link shop-name">{{
                shortName(b)
              }}</span>
              <span class="is-pulled-right" style="height: 0">
                <span class="icon">
                  <i class="far fa-heart has-text-danger" />
                </span>
              </span>
              <br />
              <!-- <span class="tag is-info">{{ b.business_type }}</span> -->
              <span class="tag is-info">{{ businessType(b) }}</span>
              <span
                class="tag is-light has-text-weight-semibold distance"
                :class="distanceColor(b.distance)"
                style="
                  margin-left: -3px;
                  border-radius: 0;
                  border-top-right-radius: 5px;
                  border-bottom-right-radius: 5px;
                "
              >
                <span v-if="b.distance">{{ b.prettyDistance }}</span>
                <span v-else>
                  <i class="fa fa-spinner fa-spin has-text-info" />
                </span>
              </span>
              <span class="is-pulled-right" v-if="$store.getters.isShops">
                <span v-if="isFreeDelivery(b)" class="tag is-danger">{{
                  $t("filter.free-delivery")
                }}</span>
                <span v-else-if="isDelivery(b)" class="tag is-primary">{{
                  $t("commerce.delivery")
                }}</span>
                <span v-else class="tag is-link">{{
                  $t("commerce.take-away")
                }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div
          class="card-content"
          style="padding: 12px; margin-bottom: 10px"
          @click="shopSignUpForm"
        >
          <span class="button is-white has-text-link has-text-weight-medium">{{
            $t("shop.cannot-find")
          }}</span>
          <a class="button is-rounded is-link is-outlined">{{
            $t("shop.add-it")
          }}</a>
        </div>
      </div>
      <br />
      <br />
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus";
import geo from "@/geo";

export default {
  name: "ShopList",
  data() {
    return {
      selected: null,
      sortBy: "alphabet",
      search: "", // search
      category: null,
      filter: null,
      z: 0,
      filters: ["Delivery", "Free Delivery", "Promo"], //, "Live"] // Open << add once hours handled
    };
  },
  computed: {
    noBusinesses() {
      if (this.businesses.length > 0) return false;
      return true;
    },
    businesses() {
      this.console("z", this.z);
      var shops = this.$store.getters.getShops;
      shops = shops.filter((b) => !b.data.hidden); // hide hidden shops from list
      if (this.search && this.search !== "") {
        shops = shops.filter((b) => b.name.toLowerCase().includes(this.search));
      }
      if (this.filter) {
        if (this.filter === "Delivery") {
          shops = shops.filter((b) => this.isAnyDelivery(b));
        }
        if (this.filter === "Free Delivery") {
          shops = shops.filter((b) => this.isFreeDelivery(b));
        }
      }
      if (this.category) {
        if (this.$store.getters.isShops) {
          var filtered = shops.filter((b) => b.business_type === this.category);
          return filtered;
        } else {
          filtered = shops.filter((b) => {
            if (b.data.categories) {
              if (b.data.categories.includes(this.category)) return true;
            }
          });
          return filtered;
        }
      }
      if (this.sortBy === "alphabet") return this.sortAlphabet(shops, "name");
      if (this.sortBy === "distance")
        return this.sortDistance(shops, "distance");
      if (this.sortBy === "category")
        return this.sortAlphabet(shops, "business_type");
      return shops; // else return all
    },
    categories() {
      if (this.$store.getters.isShops) {
        return [...new Set(this.businesses.map((b) => b.business_type))];
      }
      // else services
      return [
        ...new Set(
          this.businesses.map((b) => {
            if (b.data.categories) return b.data.categories.split(",")[0];
          })
        ),
      ];
    },
  },
  activated() {
    this.console("activated shopList");
    setTimeout(() => this.updateDistances(), 500);
  },
  deactivated() {
    this.filter = null;
    this.sortBy = "alphabet";
  },
  mounted() {
    this.updateDistances();

    EventBus.$on("SHOP_LIST_SORT", (type) => {
      this.sortBy = type;
      if (type === "filter") this.filter = "Delivery";
    });
    EventBus.$on("SHOP_LIST_SEARCH", (search) => (this.search = search));
    EventBus.$on("SHOP_LIST_CHANGE", () => {
      this.updateDistances();
      this.category = null;
      this.filter = null;
    });
  },
  methods: {
    defaultImg(e) {
      e.target.src = this.$store.state.menuItemPlaceholderPic;
    },
    translateFilter(f) {
      var name = f.toLowerCase().replace(/\s+/g, "-"); // if multi-word how?
      return this.$t(`filter.${name}`);
    },
    // translateCategory(c) {
    //   if (!c) return null;
    //   var name = c.toLowerCase().replace(/\s+/g, "-"); // if multi-word how?
    //   return this.$t(`category.${name}`);
    // },
    shopSignUpForm() {
      // var url = `https://docs.google.com/forms/d/e/1FAIpQLSf-5CrBW6qsk7E63nFbM7zJxnaX65mghNhMHHHNyJxr6h18Rg/viewform`;
      var url = this.$t("shop.sign-up-form");
      console.log("url", url);
      window.open(url, "_blank");
    },
    updateDistances() {
      this.businesses.forEach((b) => {
        var coords = this.$store.getters.getUserLatLon;
        b.distance = geo.distanceToUserInMeters(coords, b);
        b.prettyDistance = geo.prettyDistance(b.distance, 99);
      });
      this.z += 1; // force update
    },
    distanceColor(distance) {
      if (distance < 1500) return "color1";
      if (distance < 5000) return "color2";
      if (distance < 10000) return "color3";
      return "color4";
    },
    businessType(b) {
      // main category to show in shops list
      var cat = b.business_type; // default cat is business_type
      if (!this.$store.getters.isShops) {
        // else it's services so get first category if exists
        if (b.data.categories) cat = b.data.categories.split(",")[0];
      }
      return this.translateCategory(cat);
    },
    shortName(b) {
      return this.shortenString(b.name, 30);
    },
    commerceWorkflow(b) {
      if (!b.workflows) return false;
      var commerce = b.workflows.find(
        (w) => w.workflow_type_name === "Commerce"
      );
      return commerce;
    },
    isFreeDelivery(b) {
      var commerce = this.commerceWorkflow(b);
      if (!commerce) return false;
      if (commerce.data.free_delivery) return true;
      return false;
    },
    isDelivery(b) {
      var commerce = this.commerceWorkflow(b);
      if (!commerce) return false;
      if (commerce.data.free_delivery) return false;
      if (commerce.data.delivery) return true;
      return false;
    },
    isAnyDelivery(b) {
      return this.isDelivery(b) || this.isFreeDelivery(b);
    },
    isTakeAway(b) {
      if (!b.workflows) return false;
      return true;
    },
    sortAlphabet(arr, field) {
      return arr.sort((a, b) => {
        var textA = a[field].toUpperCase();
        var textB = b[field].toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
    },
    sortDistance(arr, field) {
      return arr.sort((a, b) => {
        return a[field] < b[field] ? -1 : a[field] > b[field] ? 1 : 0;
      });
    },
    businessProfilePic(b) {
      if (b.profile_pic_url) return b.profile_pic_url;
      return "https://i.ibb.co/DK0f6y3/TUK-Esssentials-profile.png"; // default profile photo
    },
    openShopPage(businessID) {
      this.$store.commit("selectBusiness", businessID);
      setTimeout(() => {
        this.$router.push(`/shop/${businessID}`);
      }, 250);
    },
    tagColor(type) {
      var accommodations = ["Apartment", "Condominium", "Hotel"];
      if (accommodations.includes(type)) return "is-success";
      var transport = ["Songthaew", "Tuk Tuk", "Motocy", "Sii Lor", "Taxi"];
      if (transport.includes(type)) return "is-danger";
      var services = ["Bar", "Restaurant", "Shop"];
      if (services.includes(type)) return "is-info";
      if (type === "Other" || type === "Service") return "is-dark";
      if (type === "TUK") return "is-warning";
    },
  },
};
</script>

<style scoped>
.shop-list {
  width: 100vw;
  height: calc(100vh - 160px);
  overflow: hidden;
}
.dark {
  background-color: #123;
  color: white;
}
.dark .card-content {
  background-color: rgb(0, 56, 113);
  color: white;
}
.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.shops-wrapper {
  /* border-top: 1px solid #ddc; */
  border-top: 1px solid rgba(68, 68, 68, 0.2);
}
.shop-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}
img {
  border-radius: 5px;
  object-fit: cover;
  height: 64px;
  width: 64px;

  /* border-radius: 50%; */
  /* background: url("../assets/live-stripes.jpg"); */
  background: rgba(128, 128, 128, 0.5);
  padding: 1px;
}
.shop-card:active {
  transform: rotate(355deg);
  -webkit-transform: rotate(355deg);
  -ms-transform: rotate(355deg);
}
.sort-by {
  width: 100vw;
  padding-bottom: 12px;
}
.tag {
  padding: 6px;
}
.button {
  padding: 9px;
}
.distance {
  text-shadow: 0 0 1px white;
}
.color1 {
  color: #1a9850 !important;
}
.color2 {
  color: #91cf60 !important;
}
.color3 {
  color: #fc8d59 !important;
}
.color4 {
  color: #d73027 !important;
}
</style>